export const SERVICES = "Services";
export const PRODUCTS = "Products";
export const ADD_ONS = "Add-On Plans";
export const SPECIAL = "Special"; // "Paid in Clinic"

export const GL_SERVICE_ID = 8;
export const GL_PRODUCT_ID = 9;
export const GL_ADD_ON_ID = 10;
export const GL_SPECIAL_ID = 12;